import * as React from 'react';
import './introcomponent.css';
import KillPageStore from "../../fbobjects/KillPageStore";
import * as _ from 'lodash';
import {valueFromAST} from "graphql";

interface IntroCProps{

}

const regions = {
    RU:'ru',
    KR:'kr',
    BR:'br1',
    OCE:'oc1',
    JP:'jp1',
    NA:'na1',
    EUN:'eun1',
    EUW:'euw1',
    TR:'tr1',
    LAN:'la1',
    LAS:'la2'
};

export default class IntroC extends React.Component<IntroCProps,any> {

    constructor(props:IntroCProps){
        super(props);
        this.state = {
            curGameSearchText: "",
            timerReference: null,
            searching: false,
            searchStatus: null,
            region: 'na1',
        };

    }

    handleSearch(){
        KillPageStore.actionLookupCurrentGame(this.state.curGameSearchText, this.state.region);
    }

    handleOnEnterDown(e){
        if (e.key == 'Enter'){
            this.handleSearch();
        }
    }

    handleChooseOpponentFromCurGame(e){
        if(e.target.value != "NONE"){
            KillPageStore.actionSelectThemFromCurrentGame(e.target.value);
        }
    }

    handleTextChange(e){
        this.setState({"curGameSearchText":e.target.value});
    }


    renderCurGameSelect(){

        let options = [];

        if(KillPageStore.curGameData != undefined){
            let otherTeam = KillPageStore.curGameData.otherTeam;
            for (let i = 0; i < otherTeam.length; i++) {
                let other = otherTeam[i];
                options.push(<option key={i} value={other.summonerName}>{`${other.champName} - ${other.summonerName}`}</option>)
            }
        }

        return <select className="select-them" disabled={!KillPageStore.gameFound} value={KillPageStore.curGameOpponentName} onChange={this.handleChooseOpponentFromCurGame.bind(this)}>
            {/*<option value={"NONE"}>None</option>*/}
            {options}
        </select>
    }


    handleRegionChange(e){
        this.setState({region:e.target.value});
    }

    renderRegionSelect(){
        let regionOptions = [];
        _.forOwn(regions, (value, key)=>{
            regionOptions.push(<option value={value} key={key}>{key}</option>)
        });
        return <select className="select-region" disabled={KillPageStore.loading} value={this.state.region} onChange={(e)=>this.handleRegionChange(e)}>
            {regionOptions}
        </select>
    }

    renderLoading(){
        let loading = KillPageStore.loading;
        if (loading){
            return <button className="load-button-loading" style={{background:'gray'}}>
                <span>Searching...</span>
            </button>

        }
        return <button className="load-button" disabled={this.state.curGameSearchText == ""} onClick={()=>{this.handleSearch()}}>
            <span disabled={this.state.curGameSearchText == ""}>Search</span>
        </button>
    }

    renderLookupStatus(){
        let lookupStatus = KillPageStore.getCurGameLookupStatus();
        let curPlayerName = KillPageStore.getCurGamePlayerName();
        let loading = KillPageStore.loading;
        if (curPlayerName != ''){
            if (lookupStatus && !loading){
                return `Got it! Found ${curPlayerName}'s game and updated it in the matchup below!`;
            }
            else if (!lookupStatus && !loading){
                return `Sorry, we couldn't find a game for ${curPlayerName}. If ${curPlayerName} is in the loading screen, please wait one minute and try again.`;
            }
        }
        return <div></div>;

    }


    render(){

        return(
            <div className='intro-container'>
                <div className="intro-title">
                    <div>
                        DAMAGE CALCULATOR
                    </div>
                    <div className="alpha">
                        ALPHA
                    </div>
                </div>
                <div className="divider"/>
                <div className="intro-subtitle">
                    Know exactly how much damage it takes to kill your opponent
                </div>
                {/*<div className="explanation-outer-container">*/}
                    {/*<div className="explanation-container">*/}
                        {/*<div className="explanation-long">*/}
                            {/*<div className="single-explanation">*/}
                                {/*<div className="title">*/}
                                    {/*Option 1 | Search for your live game*/}
                                {/*</div>*/}
                                {/*<div className="img-container">*/}
                                    {/*<img className="img" src="//opgg-static.akamaized.net/images/site/index/LiveGame.png"/>*/}
                                {/*</div>*/}

                                {/*<div className="desc">*/}
                                    {/*Search for your current game, pick your opponent, and have all of the information (runes, masteries, skill order) pulled from the current game.*/}
                                {/*</div>*/}
                                {/*/!*<button className="button">Search Live Game</button>*!/*/}
                            {/*</div>*/}
                            {/*<div className="single-explanation">*/}
                                {/*<div className="title">*/}
                                    {/*Option 2 | Create a custom matchup*/}
                                {/*</div>*/}
                                {/*<div className="img-container">*/}
                                    {/*<img className="img" src="//opgg-static.akamaized.net/images/site/index/LiveGame.png"/>*/}
                                {/*</div>*/}

                                {/*<div className="desc">*/}
                                    {/*Choose your champion and an enemy champion. We automatically input the most frequently used runes, masteries and skill orders used in Diamond+ games.*/}
                                {/*</div>*/}
                                {/*/!*<button className="button">Create Custom Matchup</button>*!/*/}
                            {/*</div>*/}
                            {/*/!*<div className="single-explanation" style={{marginRight:0}}>*!/*/}
                                {/*/!*<div className="title">*!/*/}
                                    {/*/!*3 | See your damage*!/*/}
                                {/*/!*</div>*!/*/}
                                {/*/!*<img className="img" src="//opgg-static.akamaized.net/images/site/index/LiveGame.png"/>*!/*/}
                                {/*/!*<div className="desc">*!/*/}
                                    {/*/!*Get a level-by-level analysis of your champion's all-in combos. We also give you the exact health the opponent needs to be at to kill them.*!/*/}
                                {/*/!*</div>*!/*/}
                            {/*/!*</div>*!/*/}
                        {/*</div>*/}
                    {/*</div>*/}
                {/*</div>*/}
                <div className="iframe-container">
                    <iframe className="iframe" src="https://www.youtube.com/embed/UaOEOcL5TVo" ></iframe>
                </div>
                <div className="matchup-outer-container">
                    <div className="matchup-title">
                        SEARCH LIVE GAME
                    </div>
                    <div className="matchup-inner-container">
                        <div className="step-1-container">
                            <div className="region-container">
                                <div>
                                    1. Choose a region
                                </div>
                                {this.renderRegionSelect()}
                            </div>
                            <div className="me">
                                <div>
                                    2. Type a summoner name
                                </div>
                                <input className="input-me" disabled={KillPageStore.loading} type="text" value={this.state.curGameSearchText} onKeyDown={(e)=>{this.handleOnEnterDown(e)}} onChange={(e)=>{this.handleTextChange(e)}} />
                            </div>
                        </div>
                       <div className="step-2-container">
                           <div className="button-container">
                               {this.renderLoading()}
                           </div>
                           <div className="them">
                               <div>
                                   3. Choose an enemy laner
                               </div>
                               {this.renderCurGameSelect()}
                           </div>
                       </div>

                    </div>
                    <div className="lookup-status">
                        {this.renderLookupStatus()}
                    </div>

                </div>

                {/*<div className="what-is-this">*/}
                    {/*What is this and how do I use it?*/}
                {/*</div>*/}
                {/*<div className="button-container">*/}
                    {/*<button className="load-button" onClick={()=>{this.handleSearch()}}>Load Game</button>*/}
                    {/*<div className="or">*/}
                        {/*OR*/}
                    {/*</div>*/}
                    {/*<button className="custom-matchup-button">Custom Matchup</button>*/}
                {/*</div>*/}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/IntroC/index.tsx